import { InfoOutlined } from '@mui/icons-material';
import { Box, Tooltip, Typography } from '@mui/material';
import { type ReactNode } from 'react';

type LegendProps = {
  readonly elements: { label: string; depiction: string | ReactNode }[];
};

export const Legend = ({ elements }: LegendProps) => (
  <Tooltip
    title={
      <Box display="flex" flexDirection="column" gap={1} pt={1} pb={1} pr={8} pl={1} minWidth="100px">
        {elements.map((e) => (
          <Box key={e.label} display="flex" gap={1} alignItems="center">
            {typeof e.depiction === 'string' ? (
              <Box sx={{ backgroundColor: e.depiction, borderRadius: '50%', width: '12px', height: '12px' }} />
            ) : (
              e.depiction
            )}
            <Typography variant="paragraphSm" color="secondary">
              {e.label}
            </Typography>
          </Box>
        ))}
      </Box>
    }
    placement="left"
    disableInteractive
    arrow
  >
    <Box display="flex" alignItems="center" color="text.secondary" gap={0.5}>
      <InfoOutlined sx={{ fontSize: '16px' }} />
      <Typography variant="paragraphSm" color="text.secondary">
        Legende
      </Typography>
    </Box>
  </Tooltip>
);
